import PropTypes from 'prop-types';

import { XIcon } from '../../atoms/Icons';

function MessageHistoryFilterField({
  className = '',
  clearLabel = 'Clear filter',
  hasSelection = false,
  onClear = () => {},
  children,
}) {
  return (
    <div className={`MessageHistoryPage-filterField ${className}`.trim()}>
      <div className="MessageHistoryPage-filterFieldControl">{children}</div>
      {hasSelection ? (
        <button
          type="button"
          className="MessageHistoryPage-filterClear"
          onClick={onClear}
          aria-label={clearLabel}
          title={clearLabel}
        >
          <XIcon className="MessageHistoryPage-filterClearIcon" />
        </button>
      ) : null}
    </div>
  );
}

MessageHistoryFilterField.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  clearLabel: PropTypes.string,
  hasSelection: PropTypes.bool,
  onClear: PropTypes.func,
};

export default MessageHistoryFilterField;
